import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('SUB_COMMENTS').plugin(axiosPlugin, {template: "multiArray"});

let fetchCommentsAction = redux.fetchActionGet();

redux.reducerForType('ADD', (state,payload) => {
    let newState = {...state};
    let isAlreadyExisting = newState[payload.data.parentId].data.filter(item => item._id.toString() === payload.data._id.toString());
    if (isAlreadyExisting.length === 0) {
        newState[payload.data.parentId].data.unshift(payload.data);
        newState[payload.data.parentId].total++;
        return newState;
    }
});

redux.reducerForType('DELETE', (state,payload) => {
    let newState = {...state};
    if(payload.data && payload.data._id){
        newState[payload.data.parentId].data = newState[payload.data.parentId].data.filter(item => item._id.toString() !== payload.data._id.toString());
        newState[payload.data.parentId].total--;
        if(newState[payload.data.parentId].total < 0){
            newState[payload.data.parentId].total = 0;
        }
    }
    return newState;
});

redux.reducerForType('UPDATE', (state,payload) => {
    let newState = {...state};
    if(payload.data && payload.data._id){
        newState[payload.data.parentId].data = newState[payload.data.parentId].data.map(item => {
            if(item._id.toString() === payload.data._id.toString()){
                item = payload.data;
            }
            return item;
        });
    }
    return newState;
});

export const fetchSubComments = (type, parentId, commentId, query = {}, more = false) => fetchCommentsAction(`/${type}/${parentId}/comments/${commentId}/subcomments?${queryString.stringify(query)}`, null, {key: commentId, more});
export const resetSubComments = (keys) => redux.actions.unsetKeys(keys);

export const subComments = redux.reducer();